// extracted by mini-css-extract-plugin
export var bullet = "_sa-q";
export var bulletText = "_sa-p";
export var bullets = "_sa-k";
export var callout = "_sa-g";
export var calloutBody = "_sa-i";
export var calloutLabel = "_sa-h";
export var checkIcon = "_sa-m";
export var checkList = "_sa-j";
export var checkSvg = "_sa-n";
export var checkText = "_sa-o";
export var fieldCard = "_sa-1";
export var fieldDescription = "_sa-5";
export var fieldHeader = "_sa-3";
export var fieldTitle = "_sa-4";
export var finalNote = "_sa-s";
export var flow = "_sa-x";
export var flowArrow = "_sa-v";
export var flowStep = "_sa-u";
export var helperText = "_sa-r";
export var inlineTitle = "_sa-t";
export var listItem = "_sa-l";
export var noteBody = "_sa-8";
export var noteBodyText = "_sa-9";
export var noteCard = "_sa-2";
export var noteIcon = "_sa-6";
export var noteTitle = "_sa-7";
export var productChoices = "_sa-w";
export var radioDot = "_sa-d";
export var radioDotSelected = "_sa-e";
export var radioDotSvg = "_sa-f";
export var selectableCard = "_sa-b";
export var selectableCardSelected = "_sa-c";
export var strongText = "_sa-a";
export var subHeading = "_sa-0";